import React from 'react';
import Bodentemperatur from '../components/Bodentemperatur';
import './home.css'; // gleiche Styles wie bei Home verwenden

function BodentemperaturJochberg() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="bodentemperatur-jochberg-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="bodentemperatur-jochberg-heading">BODENTEMPERATUR</h1>
        </div>

        <Bodentemperatur ort="jochberg" />
      </div>
    </div>
  );
}

export default BodentemperaturJochberg;
